import { string, ref } from "yup";
export var PasswordSetText;
(function (PasswordSetText) {
    PasswordSetText["PASSWORD"] = "Password";
    PasswordSetText["CONFIRM_PASSWORD"] = "Confirm Password";
    PasswordSetText["SET_YOUR_PASSWORD"] = "Set your password";
    PasswordSetText["SHORT_PASSWORD"] = "Password must be at least 6 characters";
    PasswordSetText["PASSWORDS_MUST_MATCH"] = "Passwords must match";
    PasswordSetText["BACK_TO_LOGIN"] = "Back to Login";
    PasswordSetText["SUBMIT"] = "Submit";
    PasswordSetText["GENERIC_ERROR"] = "Something went wrong. Please request a new Recovery Email.";
})(PasswordSetText || (PasswordSetText = {}));
//TODO: Export from shared instead of repeating?
/**
 * Func to provide error messages with field names (where possible).
 * @param fieldName
 * @returns String error message. E.g., "First Name field is required."
 */
const errMsg = (fieldName) => `${fieldName} is required.`;
export const passwordSetSchema = {
    password: string().required(errMsg(PasswordSetText.PASSWORD)).min(6, PasswordSetText.SHORT_PASSWORD),
    confirmPassword: string()
        .required(errMsg(PasswordSetText.CONFIRM_PASSWORD))
        .oneOf([ref("password")], PasswordSetText.PASSWORDS_MUST_MATCH),
};
